import type { AccountProfile, PasswordParams } from '@/domain/account/Account'
import type { AccountRepository } from '@/domain/account/AccountRepository'
import type { AgentId } from '@/domain/shared/Brand'
import { API_PATHS } from '@/infrastructure/http/ApiPaths'
import type { HttpClient } from '@/infrastructure/interfaces/HttpClient'
import { toAccountProfile } from '@/infrastructure/mapper/ApiToDomainMapper'
import { compilePath } from '@/shared/PathUtils'

export class HttpAccountRepository implements AccountRepository {
  constructor(private readonly httpClient: HttpClient) {}

  async getProfile(agentId: AgentId): Promise<AccountProfile> {
    const response = await this.httpClient.request({
      path: compilePath(API_PATHS.ACCOUNT.PROFILE, { agentId }),
      method: 'GET',
    })
    return toAccountProfile(response)
  }

  async updateNickname(agentId: AgentId, nickname: string): Promise<void> {
    await this.httpClient.request({
      path: compilePath(API_PATHS.ACCOUNT.UPDATE_NICKNAME, { agentId }),
      method: 'PUT',
      body: {
        nickname: nickname,
      },
    })
  }

  async updatePassword(
    agentId: AgentId,
    params: PasswordParams,
  ): Promise<void> {
    await this.httpClient.request({
      path: compilePath(API_PATHS.ACCOUNT.UPDATE_PASSWORD, { agentId }),
      method: 'PUT',
      body: {
        old_password: params.oldPassword,
        new_password: params.newPassword,
      },
    })
  }
}
